import React from 'react';
import PropTypes from 'prop-types';
import CrossRoad from "../UI/Crossroad";

const CrossRoad_1CBlue_1ARed = props => (
   <CrossRoad coords="850.000000, 952.000000" />
);

CrossRoad_1CBlue_1ARed.propTypes = {};

export default CrossRoad_1CBlue_1ARed;
